import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/contents/feed/index.tsx");
